/**
 * FieldSymbol is much similar to TextSymbol. The only difference is that the text for a FieldSymbol 
 * comes from a field value of the data.
 */
define("tmds/symbols/FieldSymbol", [
	"jquery",
	"./Font",
	"./Symbol",
	"./utils",
    "../validator"
], function($, Font, Symbol, utils, validator) {
	"use strict";
	
	/**
	 * construct a new FieldSymbol
	 * @param options {Object} object with below structure
	 * 		{
	 * 			field: "fieldName",
	 * 			color: [255,0,0,0.5],
	 * 			anchor: "middle",
	 * 			xOffset: 10,
	 * 			yOffset: 20,
	 * 			font: {
	 * 				family: "serif",
	 * 				size: 12,
	 * 				style: "normal",
	 * 				weight: "bold"
	 * 			}
	 * 		}
	 * @note field is required. All other members are optional
	 * @see {tmds.symbols.Font} for font details
	 */
	var FieldSymbol = function(options) {
		
		Symbol.call(this, options);
		
		// default text symbol settings
		this.field = "";
		this.color = [0,0,0,1];
		this.font = new Font();
		this.anchor = 'middle';
		this.xOffset = 0;
		this.yOffset = 0;
		
		if (options != undefined) {
			if (validator.isDataObject(options)) {
				
				if(options.field != undefined) 
					setField.call(this, options.field);
					
				if(options.color != undefined) 
					setColor.call(this, options.color);
				
				if(options.anchor != undefined) 
					setAnchor.call(this, options.anchor);
				
				if(options.xOffset != undefined || options.yOffset != undefined) 
					setOffset.call(this, options.xOffset, options.yOffset);
				
				if(options.font != undefined)
					setFont.call(this, options.font);
			}
			else if (validator.isString(options)) {
				this.field = options;
			}
			else {
				throw new Error('Invalid options values - ' + options + ' passed');
			}
		}
	};
	
	/**
	 * set the text color
	 * @param color {Array} [r,g,b,a]
	 * @return the symbol itself
	 */
	function setColor(color) {
		
		var _color = utils.toColorArray(color);

		if(_color === false) {
			
			throw new Error('Invalid color value - ' + color + ' passed');
		}
		
		this.color = _color;
		return this;
	}
	
	/**
	 * set the text symbol anchor
	 * @param anchor {String}
	 * @return the symbol itself
	 */
	function setAnchor(anchor) {
		
		if(! validator.isValidAnchor(anchor)) {
			
			throw new Error('Invalid anchor value - ' + anchor + ' passed');
		}
		
		this.anchor = anchor;
		return this;
	}
	
	/**
	 * set the text font
	 * @param font {tmds.symbols.Font}
	 * @return the symbol itself
	 */
	function setFont(font) {
		
		if(! validator.isDataObject(font)) {
			
			throw new Error('Invalid font value - ' + font + ' passed');
		}
		
		this.font = new Font(font);
		
		return this;			
	}
	
	/**
	 * set which field value will be used to display the text
	 * @param text {String} field name
	 * @return the symbol itself
	 */
	function setField(fldName) {
		
		if(! validator.isString(fldName)) {
			
			throw new Error('Invalid Field name - ' + fldName + ' passed');
		}
		
		this.field = fldName;
		return this;
	}
	
	/**
	 * set the symbol offset
	 * @param x {Number} new x offset value
	 * @param y {Number} new y offset value
	 * @return the symbol itself
	 */
	function setOffset(x, y) {
		
		var validX = validator.isNumber(x),
			validY = validator.isNumber(y);
		
		if((x != undefined && ! validX) || (y != undefined && ! validY) || (x == undefined && y == undefined)) {
			
			throw new Error('Invalid xOffset, yOffset values - ' + x  + ' , ' + y + ' passed');
		}
		
		if(validX) this.xOffset = Number(x);
		
		if(validY) this.yOffset = Number(y);
		
		return this;
	}
	
	/**
	 * convert TextSymbol object to JSON representation
	 */
	function toJson() {
		return {
			type: this.type,
			field: this.field,
			color: this.color,
			font: this.font.toJson(),
			anchor: this.anchor,
			xOffset: this.xOffset,
			yOffset: this.yOffset
		};
	}
		
	// TextSymbol inherits Symbol with some extensions
	FieldSymbol.prototype = $.extend(Object.create(Symbol.prototype), {
		
		declaredClass: "tmds.symbols.FieldSymbol",
		type: "FieldSymbol",
		'setColor' : setColor,
		'setAnchor' : setAnchor,
		'setFont' : setFont,
		'setField' : setField,
		'setOffset' : setOffset,
		'toJson' : toJson
	});
	
	return FieldSymbol;
});